import SelectLMWH from "../../../../src/components/content/SelectLMWH";
import * as React from 'react';
export default {
  SelectLMWH,
  React
};